/**
 * @file Helper functions for generating links for mobile navigation
 */

import { Hotel } from '../../../generated/graphql';
import translate from '../../../i18n/translate';
import { getChatbotLuluUrl } from '../../../routes/urls/chatbot';
import { getDevPanelUrl } from '../../../routes/urls/devPanel';
import { getSelectHotelUrl } from '../../../routes/urls/more';
import { getSettingsUrl } from '../../../routes/urls/settings';
import { getCanViewDevPanel } from '../../../utils/permissions/devPanel';
import { NavigationLinkProps } from '../../MUI/MobileFullViewNavigation/NavigationLink';

/**
 * Generates a list of navigation lists with data
 *
 * @param hotelId              The current hotel ID
 * @param nrHotels             The number of hotels the user has access to
 * @param canAccessChatbotLulu Whether the user can access Chatbot Lulu
 * @returns                    The links to show
 */
export const generateLinks = (
  hotelId: Hotel['id'] | null,
  nrHotels: number,
  canAccessChatbotLulu: boolean,
): NavigationLinkProps[] => {
  const devPanelUrl = getDevPanelUrl(hotelId);
  const selectHotelUrl = nrHotels < 2 ? '' : getSelectHotelUrl(hotelId);
  const settingsUrl = getSettingsUrl(hotelId);

  const links: NavigationLinkProps[] = [
    {
      icon: 'settings',
      isDisabled: false,
      isExternal: false,
      label: translate('GENERAL__SETTINGS'),
      url: settingsUrl,
    },
    {
      icon: 'changeObject',
      isDisabled: selectHotelUrl === '',
      isExternal: false,
      label: translate('GENERAL__CHANGE_OBJECT'),
      url: selectHotelUrl,
    },
  ];

  if (canAccessChatbotLulu && hotelId !== null) {
    links.push({
      icon: 'chatbotLulu',
      isDisabled: false,
      isExternal: false,
      label: translate('NAVIGATION__CHATBOT_LULU'),
      url: getChatbotLuluUrl(hotelId),
    });
  }

  if (getCanViewDevPanel()) {
    links.push({
      icon: 'devPanel',
      isDisabled: false,
      isExternal: false,
      label: translate('DEBUG__DEV_PANEL__LINK'),
      url: devPanelUrl,
    });
  }

  return links;
};
